import { render } from "./ExportPdfModal.vue?vue&type=template&id=22b15a56&ts=true"
import script from "./ExportPdfModal.vue?vue&type=script&lang=ts"
export * from "./ExportPdfModal.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/stamincasa/stamincasa-matematica/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__